export default {
	ids: ['zoom', 'roll', 'tilt', 'perspective', 'elevation', 'pan', 'wobble_view', 'wobble_rate'],
	glsl: `
const float TAU = 6.28318530718;

// o/d: the ray in stage units about the frame centre, finite at k 0 (parallel rays, d the view axis). p: its hit on the plane in frame coordinates (vUV * extent at tilt 90). screen: the pixel on the screen plane in the camera's frame (rolled, pan included), stage units: the tube's (surface). depth: the plane hit's distance from the screen plane along the view axis, su. unit: stage units per su on the surface (zoom folded in). hit: 1 on the plane, 0 past its horizon.
struct Ray {
	vec3 o;
	vec3 d;
	vec2 p;
	vec2 screen;
	float depth;
	float unit;
	float hit;
};

// The pixel's ray, for the rows, which meet it plane by plane (light stage).
Ray viewRay;
// The view rolling side to side, radians (cube's wobble); 0 at wobble_view 0 exactly.
float viewWobble;

Ray camera(vec2 uv) {
	vec2 extent = uResolution;
	vec2 P = uv * extent;
	vec2 c = P - 0.5 * extent;
	viewWobble = sin(TAU * uWobbleRate / 20.0) * uWobbleView * 1.2;
	float r = radians(uRoll) - viewWobble;
	mat2 turn = mat2(cos(r), sin(r), -sin(r), cos(r));
	c = turn * c;
	// Pitch down from the horizon, so tilt 90 gives cos 1, sin 0 exactly and a lower tilt sees a floor.
	float a = radians(uTilt - 90.0);
	float cp = sin(a);
	float sp = cos(a);
	float k = uPerspective / (200.0 * uStageUnit);
	float e = uElevation * uStageUnit;
	float den = sp - k * c.y * cp;
	Ray ray;
	ray.o = vec3(c.x, c.y * sp, c.y * cp + e);
	ray.d = vec3(k * c.x, cp + k * c.y * sp, -sp + k * c.y * cp);
	ray.unit = uStageUnit * uZoom;
	ray.hit = den > 1e-6 ? 1.0 : 0.0;
	den = max(den, 1e-6);
	ray.screen = turn * (P - 0.5 * extent + uPan * uStageUnit);
	// d's part along the view axis is 1, so the hit's parameter is its distance.
	ray.depth = max((c.y * cp + e) / den, 0.0) / uStageUnit;
	vec2 hitP = vec2((sp + k * e) * c.x, cp * (e + c.y * cp) + (sp + k * e) * c.y * sp) / den;
	// The offset from the screen point, exactly 0 at the identity, so p is P bit for bit there.
	ray.p = P + (hitP - c) + uPan * uStageUnit;
	viewRay = ray;
	return ray;
}
`,
}
